<div *ngIf="loading" class="overlay" [ngStyle]="{ 'background-color': shadingColor, position: positionRelative ? 'relative' : 'fixed' }">
  <div class="spinner__container">
    <div class="spinner__icon"></div>
    <div class="spinner__text">{{ message }}</div>
  </div>
</div>
